// extracted by mini-css-extract-plugin
export default {"callout":"Polarizing-module__callout__aohMN","callout-heading":"Polarizing-module__callout-heading__Ov_6_","img":"Polarizing-module__img__V_F2z"};